module.exports = __webpack_public_path__ + "img/generic_logo.93c4984c.png";